import React from 'react';
import { CatalogueSection } from '../../models';
import CatalogueRow from './CatalogueRow/CatalogueRow';
import CataloguePointRow from './CataloguePointRow/CataloguePointRow';

interface CatalogueProps {
  sections: CatalogueSection[];
}

function Catalogue({ sections }: CatalogueProps) {
  return (
    <div className="flex w-full flex-col">
      <CataloguePointRow />
      {sections?.map((section) =>
        section.products.length > 0 ? (
          <CatalogueRow key={section.category._id} section={section} />
        ) : null
      )}
    </div>
  );
}

export default Catalogue;
